import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";
import { Modal, Button } from "rsuite";
import apiClient from "../../libraries/ApiClient";
import { useContext } from "react";
import { ModelContext } from "../../contexts/ModelContext";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function Patient_ArrivalLanseed_CheckRegular({
  rowId,
  code,
  hospital,
  caseCode,
}) {
  const queryClint = useQueryClient();
  const [token, setToken] = useState("");
  const [name, setName] = useState("");
  const [Case, setCase] = useState("");
  const {
    setOpenAskSaveModel,
    changeData,
    openSecondModel,
    setOpenSecondModel,
    openSecondModelName,
    setOpenSecondModelName,
  } = useContext(ModelContext);

  const handleOpen = () => {
    console.log(changeData);
    setOpenSecondModelName("Patient_ArrivalLanseed_CheckRegular");
    setCase(caseCode);
    if (changeData) {
      setOpenAskSaveModel(true);
    } else {
      setOpenSecondModel(true);
    }
  };

  const open = () => {
    console.log(caseCode);
    return (
      openSecondModel &&
      openSecondModelName === "Patient_ArrivalLanseed_CheckRegular" &&
      Case == caseCode
    );
  };
  const handleClose = () => setOpenSecondModel(false);
  // console.log(code);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    setName(JSON.parse(localStorage.getItem("auth"))?.Name);
  }, []);

  const sendCheckData = async ({ rowId, code, token }) => {
    const data = {
      Data: {
        RowId: rowId,
        Code: code,
        Value: 1,
        Content: "",
      },
    };


    const res = await apiClient.postAes(
      "api/referral/SetPatientStatus/Security",
      data
    );

    return res;
  };

  const {
    data: checkData,
    mutate,
    isLoading,
  } = useMutation(sendCheckData, {
    onSuccess() {
      alert("更新成功");
      //queryClint.invalidateQueries("getListData");
      window.location.reload(true);
    },
  });
  // console.log(checkData);

  return (
    <>
      <span style={{ padding: "5px" }} onClick={handleOpen}>
        <Container
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="2.5"
            stroke="#057AFF"
          />
          <path
            d="M17.7489 8.23434C18.0837 8.54679 18.0837 9.05421 17.7489 9.36666L10.8925 15.7657C10.5577 16.0781 10.0141 16.0781 9.67928 15.7657L6.25109 12.5662C5.9163 12.2537 5.9163 11.7463 6.25109 11.4338C6.58587 11.1214 7.12956 11.1214 7.46435 11.4338L10.2872 14.0659L16.5383 8.23434C16.8731 7.92189 17.4168 7.92189 17.7516 8.23434H17.7489Z"
            fill="#057AFF"
          />
        </Container>
      </span>
      <Modal open={open()} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>病患抵達聯新國際醫院</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "14px" }}>
            由{name}操作 確認{hospital}之病患-收案編號{caseCode}抵達聯新國際醫院
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              mutate({ rowId, code, token });
            }}
            appearance="primary"
            disabled={isLoading}
          >
            {isLoading ? "資料傳送中" : "確認"}
          </Button>
          <Button onClick={handleClose}>取消</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Patient_ArrivalLanseed_CheckRegular;
